<main class="main-search-component flex flex-col">
  <section class="main-search-data-row-section mt-0 w-full flex items-center justify-center mb-0">
    <main class="main-search-section-template w-full" [class.disabled]="isDisabled">
      <section
        class="main-search-data-row-div w-full h-10 pr-0.5 pl-3 bg-white rounded-lg flex items-center relative shadow-sm"
      >
        <lbca-icon strokeWidth="2.5" name="lucide:search" [size]="'medium'" color="primary" />
        @if (tagList.length) {
        <div class="main-search-separator text-gray-800 ml-[10px] mr-2">|</div>
        } @if (tagList.length) {
        <section class="tags-box flex gap-1.5">
          @for (tag of tagList; track tag) {
          <div
            class="tag-body h-full items-center border-2 rounded-lg border-primary cursor-pointer flex flex-row relative"
          >
            <span
              class="tag-label transition duration-200 ease-in-out flex items-center text-primary truncate ml-1.5 mr-1.5"
            >
              {{ tag.key === '_general' ? tag.value : tag.valueLabel ?? tag.value }}
            </span>
            <lbca-button
              (click)="removeTag(tag)"
              icon
              size="xsmall"
              variant="unstyled"
              class="text-primary hover:text-primary-200"
            >
              <lbca-icon name="lucide:x" />
            </lbca-button>
          </div>
          }
        </section>
        }
        <div class="main-search-separator text-gray-800 ml-[10px]">|</div>
        @if (tagOpen) {
        <div class="tag-open ml-[12px] text-primary">{{ tagOpen.label + ': ' }}</div>
        }
        <div class="main-search-data-row-section-inside flex items-center relative">
          <div class="main-search-data-column flex" style="width: 100%">
            <input
              #inputSearch
              class="main-search-input-section w-full pl-[6px] text-gray-700 bg-white placeholder:text-gray-400"
              (keyup)="setInputValue($event)"
              (click)="setFocus(!isFocused)"
              (blur)="setFocus(false)"
              [placeholder]="tagOpen ? '' : placeHolder"
            />
          </div>
        </div>
        <div class="main-search-data-controllers flex justify-center items-center bg-white">
          <lbca-button
            icon
            (click)="clearSearch($event)"
            variant="unstyled"
            size="small"
            class="text-primary hvoer:text-primary-200"
          >
            <lbca-icon name="lucide:x" />
          </lbca-button>
        </div>
      </section>
    </main>
  </section>
</main>

<ng-template cdkPortal #templateTags="cdkPortal">
  <main
    class="templateSearchOptions bg-white shadow-lg w-80 mt-4 rounded-xl overflow-y-scroll max-h-80 py-2"
  >
    <div class="container-scroll flex flex-col gap-1">
      @for (option of optionsList; track option) {
      <div
        (mousedown)="selectTag($event, option)"
        class="st-option text-xs font-normal hover:font-semibold text-gray-700 h-8 px-5 hover:bg-primary-100 cursor-pointer hover:text-gray-800 flex items-center w-full transition"
      >
        {{ option.label }}
      </div>
      }
    </div>
  </main>
</ng-template>
